import * as types from "./actionTypes"

const initialState = {
    shipments: [],
    shipperTracks: [],
    trainIDs: [],
    shipmentFilterValues: [],
    selectedFilterValues: {},
    selectedCommentRow: {},
    comments: [],
    rejectReasons: [],
    actionSaveResponse: [],
    lazyPageInfo: { page: 0, size: 20 },
    selectedEquipments: [],
    waybillDetails: [],
    railCarMovementDetails: [],
    carSchedulingrailcarMovements: [],
    shipmentWayBillDetails: [],
    extractionDate: "",
    extractionNumber: "",
    shipmentsPageInfo: {},
    ebolTokenRequested: false,
    ebolToken: "",
    ebolResponse: [],
    carsSelectedInACtion: [],
    hasCommentShipments: [],
    railRoadDate: "",
    shipmentRailcars: {},
    telegraphData: {},
    telegraphDataMaped: { shipments: {} },
    telegraphDataFetch: 0, // 0:not available , 1: available, 2: failure
    dateRangeTMS: {},
    dateRangeTelgraph: {},
}
export default function visibilityReducer(state = initialState, action) {
    switch (action.type) {
        case types.VISIBILITY_SHIPMENT_LIST_FETCH_SUCCESS: {
            const trainIdFiltered = action.payload["ShipmentTrainIds"]
                ? action.payload["ShipmentTrainIds"].filter((id) => id !== "")
                : []

            return {
                ...state,
                shipperTracks: action.payload["ShipmentStationsTracks"],
                trainIDs: trainIdFiltered,
                hasCommentShipments: [],
                shipmentRailcars: action.payload["ShipmentRailcars"],
            }
        }
        case types.VISIBILITY_SHIPPER_TRACK_DETAILS_FETCH_SUCCESS:
            return {
                ...state,
                shipments: action.payload["Shipments"],
            }
        case types.VISIBILITY_SHIPPER_FILTER_VALUES_FETCH_SUCCESS: {
            const filterValues = action.payload["ShipmentsFilterFieldsValues"]
            const filters = {}
            filterValues.forEach((filter) => {
                if (filters[filter.Type])
                    filters[filter.Type].push(filter.Value?.trim())
                else filters[filter.Type] = [filter.Value?.trim()]
            })
            return {
                ...state,
                shipmentFilterValues: filters,
            }
        }
        case types.VISIBILITY_FETCH_COMMENTS:
            return {
                ...state,
                comments: [],
                selectedCommentRow: {
                    ...action.payload.data,
                },
            }
        case types.VISIBILITY_FETCH_COMMENTS_SUCCESS:
            return {
                ...state,
                comments: action.payload["comments"],
            }
        case types.VISIBILITY_POST_COMMENT_SUCCESS: {
            return {
                ...state,
                comments: [],
                hasCommentShipments: [
                    ...state.hasCommentShipments,
                    `${action.payload.carId} ${action.payload.waybillId}`,
                ],
            }
        }
        case types.VISIBILITY_REJECT_REASONS_FETCH_SUCCESS:
            return {
                ...state,
                rejectReasons: action.payload["ReasonCodes"],
            }
        case types.VISIBILITY_SAVE_ACTION_CODE_SUCCESS:
            return {
                ...state,
                actionSaveResponse: action.payload,
            }
        case types.LAZY_LOAD_SHIPMENTS_PAGEINFO:
            return {
                ...state,
                lazyPageInfo: action.payload,
            }
        case types.CLEAR_SELECTED_EQUIPMENTS:
            return {
                ...state,
                selectedEquipments: [],
            }
        case types.UPDATE_SELECTED_EQUIPMENTS:
            return {
                ...state,
                selectedEquipments: action.payload,
            }
        case types.VISIBILITY_WAYBILL_INFORMATION_FETCH_SUCCESS:
            return {
                ...state,
                waybillDetails: action.payload.Waybill,
            }
        case types.VISIBILITY_RAILCAR_MOVEMENTS_FETCH_SUCCESS:
            return {
                ...state,
                railCarMovementDetails: action.payload.RailcarMovements,
            }
        case types.VISIBILITY_GET_CAR_SCHEDULING_RAILCAR_MOVEMENTS_SUCCESS:
            return {
                ...state,
                carSchedulingrailcarMovements: action.payload.RailcarMovements,
            }
        case types.VISIBILITY_SHIPMENT_WAYBILL_FETCH_SUCCESS:
            return {
                ...state,
                shipmentWayBillDetails: action.payload.ShipmentWaybill,
            }
        case types.VISIBILITY_CLEAR_WAYBILL:
            return {
                ...state,
                shipmentWayBillDetails: [],
            }
        case types.SET_EXTRACTION_DATE:
            return {
                ...state,
                extractionDate: action.payload,
            }
        case types.SET_EXTRACTION_NUMBER:
            return {
                ...state,
                extractionNumber: action.payload,
            }
        case types.SHIPMENTS_PAGEINFO:
            return {
                ...state,
                shipmentsPageInfo: action.payload,
            }
        case types.VISIBILITY_GET_EBOL_TOKEN:
            return {
                ...state,
                ebolTokenRequested: true,
                ebolToken: "",
                ebolResponse: action.payload,
            }
        case types.VISIBILITY_GET_EBOL_TOKEN_SUCCESS:
            return {
                ...state,
                ebolTokenRequested: false,
                ebolToken: action.payload.Token,
                ebolResponse: action.payload,
            }
        case types.VISIBILITY_GET_EBOL_TOKEN_FAILURE:
            return {
                ...state,
                ebolTokenRequested: false,
                ebolToken: action.payload.Token,
                ebolResponse: action.payload,
            }
        case types.SELECT_CARS_IN_ACTIONS:
            return {
                ...state,
                carsSelectedInACtion: action.payload,
            }
        case types.CLEAR_VISIBILITY_ALL:
            return {
                ...initialState,
            }
        case types.SET_RAILROAD_DATE:
            return {
                ...state,
                railRoadDate: action.payload,
            }
        case types.PLATFORM_SERVICE_FETCH_SUCCESS: {
            let shipments = {}
            action.payload.shipments.forEach((ship) => {
                shipments[ship.railCar] = ship
            })

            return {
                ...state,
                telegraphData: { shipments: action.payload },
                telegraphDataMaped: { shipments: shipments },
                telegraphDataFetch: 1,
            }
        }
        case types.PLATFORM_SERVICE_FETCH_FAILURE: {
            return {
                ...state,
                telegraphDataFetch: 2,
            }
        }
        case types.PLATFORM_SERVICE_FETCH_CLEAR: {
            return {
                ...state,
                telegraphData: initialState.telegraphData,
                telegraphDataMaped: initialState.telegraphDataMaped,
                telegraphDataFetch: 0,
            }
        }
        case types.SEET_DATE_RANGE_TMS: {
            return {
                ...state,
                dateRangeTMS: action.payload,
            }
        }
        case types.SEET_DATE_RANGE_TELEGRAPH: {
            return {
                ...state,
                dateRangeTelgraph: action.payload,
            }
        }
        default:
            return state
    }
}
